import React from 'react';
import { primaryServices, secondaryServices, companyInfo } from '../../data/mock';

const ServicesSection = () => {
  return (
    <section id="services" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#0D2438]"></div>
      
      {/* Subtle background image - Data visualization */}
      <div className="absolute inset-0 opacity-[0.04]">
        <img 
          src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2940&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(91, 181, 197, 0.5) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(91, 181, 197, 0.5) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }}></div>

      {/* Decorative glow */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#1F7A8C]/10 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Our Services</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          SAP Services
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          <span className="text-[#E8B86D]">IJSS IT Solutions</span> delivers <span className="text-[#5BB5C5]">SAP Master Data Governance</span> as our primary specialization, 
          supported by select SAP and technology services that enable MDG-led transformation programs.
        </p>

        {/* PRIMARY SERVICES - SAP MDG */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-2.5 h-2.5 bg-[#5BB5C5] rounded-full"></div>
            <h3 className="text-[#5BB5C5] font-semibold text-xl">
              Primary Services - SAP Master Data Governance
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {primaryServices.map((service) => (
              <div key={service.id} className="service-card h-full">
                <h4 className="text-[#E8B86D] font-semibold text-lg mb-3">
                  {service.title}
                </h4>
                <p className="text-[#A8B8C8]">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* SECONDARY SERVICES */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-2.5 h-2.5 border-2 border-[#E8B86D] rounded-full"></div>
            <h3 className="text-[#E8B86D] font-semibold text-xl">
              Supporting Services
            </h3>
          </div>
          
          <p className="text-[#8899AA] text-sm mb-6 max-w-3xl">
            These services support MDG-led SAP programs. Software engineering, automation, analytics, AI, and DevOps 
            capabilities are deployed only where they strengthen MDG governance, quality, controls, and compliance.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {secondaryServices.map((service) => (
              <div key={service.id} className="service-card-secondary">
                <h4 className="text-[#5BB5C5] font-medium text-sm mb-2">
                  {service.title}
                </h4>
                <p className="text-[#8899AA] text-sm">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Framework Statement */}
        <div className="bg-gradient-to-r from-[#122A40] to-[#1A3A52] p-8 rounded-lg border border-[rgba(91,181,197,0.2)]">
          <p className="text-[#B8C8D8] font-medium">
            All <span className="text-[#5BB5C5]">SAP Master Data Governance</span> delivery is powered by the <span className="text-[#E8B86D] font-semibold">{companyInfo.frameworkTrademark}</span> governance framework.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
